import {Component, Type} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {ProductOverviewService} from '../../../../services/product-overview/product-overview.service';
import {DetailScreensRequestModel} from '../services/detail-screens-request.model';
import {DetailPopupService} from '../services/popup/detail-popup-service';
import {DetailPopupRequestModel} from '../services/popup/detail-popup-request.model';
import {CostsPopupComponent} from '../screens/popups/costs/costs-popup.component';
import {DetailPopup} from '../mapping-classes/detail-popup';
import {DebitInterestPopupComponent} from '../screens/popups/debit-interest/debit-interest-popup.component';
import {CreditInterestPopupComponent} from '../screens/popups/credit-interest/credit-interest-popup.component';
import {CommissionPopupComponent} from '../screens/popups/commission/commission-popup.component';
import {DebitCardPopupComponent} from '../screens/popups/debitcard/debitcard-popup.component';
import {AccountDirectDebitListingsComponent} from '../screens/popups/account-direct-debit-listings/account-direct-debit-listings.component'
import {MandatesComponent} from "../screens/popups/mandates/mandates.component";

@Component({
  selector: 'app-details-name-value',
  templateUrl: './details-name-value.component.html',
  styleUrls: ['../detail-screen/detail-screen.component.css'],
})

export class DetailsNameValueComponent {
  restrictedData: boolean;
  name;
  value;
  type = '';
  currencyCode;
  emptyValuePlaceholder = '-';
  clickable: boolean;
  hasPopup: boolean;
  urlLink: string;
  hasLink: boolean;
  hasLinkToSameTab: boolean;
  isPowerOfAttorney: boolean;
  transactionsDetailsBankCode: string;
  private fixedName: string;
  private componentType;

  private clickableNames = {
    Overeenkomstnummer: true,
    Referentienummer: true,
    Samenstellingnummer: true,
    Debetrenteafspraak: true,
    Creditrenteafspraak: true,
    Creditrentekernafspraak: true,
    Creditrentetransactiekasafspraak: true,
    Provisieafspraak: true,
    Kostenafspraak: true,
    Werelddelen: true,
    BlokkadeGoedkeuringslijstEuroincasso: true,
    MachtigingenEuroincasso: true,
  };

  constructor(public dialog: MatDialog,
              private productOverviewService: ProductOverviewService,
              private detailPopupService: DetailPopupService) {
  }

  ngOnInit() {
    this.fixedName = this.name.replace(/\s+/g, '').replace(/-/g, '').replace(/\//g, '');
    const clickable = this.clickableNames[this.fixedName];
    this.hasPopup = clickable || false;
  }

  getHasLink() {
    return this.hasLink;
  }

  public setHasLink(hasLink: boolean) {
    this.hasLink = hasLink;
  }

  getHasLinkToSameTab() {
    return this.hasLinkToSameTab;
  }

  public setHasLinkToSameTab(value: boolean) {
    this.hasLinkToSameTab = value;
  }

  getIsPowerOfAttorney() {
    return this.isPowerOfAttorney;
  }

  public setIsPowerOfAttorney(poa: boolean) {
    this.isPowerOfAttorney = poa;
  }

  getArrangementUrl() {
    this.productOverviewService.getArrangementUrl(
      DetailScreensRequestModel.arrangementNumber,
      DetailScreensRequestModel.administrationCode,
      DetailScreensRequestModel.bankCode,
    ).subscribe(
        (resp) => {
          const url = resp['url'];
          window.open(url, 'SIEBEL');
    });
  }

  redirectToLink() {
    if (this.urlLink.includes("https://siebel.rabobank.nl/fins_nld/redirectService.htm?ViewName=CustomerAccountSummary&MapParam1=") ||
      this.urlLink.includes("https://siebel.rabobank.nl/fins_nld/redirectService.htm?ViewName=CustomerHouseholdSummary&MapParam1=") || this.getIsPowerOfAttorney
    ) {
      console.log("volmacht redirect");
       window.open(this.urlLink, 'SIEBEL');
    }else{
     window.open(this.urlLink, '_blank');
    }
  }

  redirectToLinkSameTab() {
        if (this.urlLink.includes("https://siebel.rabobank.nl/fins_nld/redirectService.htm?ViewName=CustomerAccountSummary&MapParam1=") ||
          this.urlLink.includes("https://siebel.rabobank.nl/fins_nld/redirectService.htm?ViewName=CustomerHouseholdSummary&MapParam1=") || this.getIsPowerOfAttorney
        ) {
          console.log("volmacht redirect");
           window.open(this.urlLink, 'SIEBEL');
        }else{
         window.open(this.urlLink, '_self');
        }
  }

  openPopup() {
    const popUpComponentType = {
      Debetrenteafspraak: {url: 'debit-interest', component: DebitInterestPopupComponent },
      Creditrenteafspraak: {url: 'credit-interest', component: CreditInterestPopupComponent },
      Creditrentekernafspraak: {url: 'credit-interest', component: CreditInterestPopupComponent },
      Creditrentetransactiekasafspraak: {url: 'credit-interest', component: CreditInterestPopupComponent },
      Provisieafspraak: {url: 'commission', component: CommissionPopupComponent },
      Kostenafspraak: {url: 'costs', component: CostsPopupComponent },
      Werelddelen: {url: 'continents', component: DebitCardPopupComponent },
      BlokkadeGoedkeuringslijstEuroincasso: {url: 'accountdirectdebitlistings', component: AccountDirectDebitListingsComponent},
      MachtigingenEuroincasso: {url: 'mandates', component: MandatesComponent}
    };

    this.componentType = this.name === '' ? popUpComponentType['Debetrenteafspraak'] : popUpComponentType[this.fixedName];
    if (this.componentType) {
      if (this.componentType.url === 'continents') {
        this.openContinentsPopup(this.componentType.url, this.componentType.component);
      } else {
        this.openDetailScreenPopup(this.componentType.url, this.componentType.component);
      }
    }

  }

  private openDetailScreenPopup(url: string, detailPopupType: Type<DetailPopup>) {
    DetailPopupRequestModel.arrangementNumber = DetailScreensRequestModel.arrangementNumber;
    DetailPopupRequestModel.bankCode = this.transactionsDetailsBankCode || '0';
    DetailPopupRequestModel.tableNumber = this.value || '0';
    DetailPopupRequestModel.relationRestrictedDataView = DetailScreensRequestModel.relationRestrictedDataView;
    DetailPopupRequestModel.restrictedDataViewException = DetailScreensRequestModel.restrictedDataViewException;
    DetailPopupRequestModel.relationMarketSegmentCode = DetailScreensRequestModel.relationMarketSegmentCode;
    this.openCurrentPopup(url, detailPopupType, 'getComposedAccountPopup');
  }

  private openContinentsPopup(url: string, detailPopupType: Type<DetailPopup>) {
    DetailPopupRequestModel.arrangementNumber = DetailScreensRequestModel.arrangementNumber || '';
    DetailPopupRequestModel.administrationCode = DetailScreensRequestModel.administrationCode || '';
    this.openCurrentPopup(url, detailPopupType, 'getContinentPopup');

  }

  private openCurrentPopup(url: string, detailPopupType: Type<DetailPopup>, popUpType: string) {
    this.detailPopupService[popUpType](url)
      .subscribe(
        (resp) => {
          this.dialog.open(detailPopupType, {
            width: '800px',
            data: resp,
            panelClass: 'custom-modalbox',
          });
        });
  }
}
